/* Quick View Modal JS (no dependencies) */
(function () {
  if (window.__dsQuickViewInit) return;
  window.__dsQuickViewInit = true;

  function money(cents) {
    try {
      var currency =
        (window.Shopify &&
          Shopify.currency &&
          (Shopify.currency.active || Shopify.currency.current)) ||
        "USD";
      return (cents / 100).toLocaleString(undefined, {
        style: "currency",
        currency: currency,
      });
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  // Select Liquid-rendered overlay and modal
  var overlay = document.getElementById("ds-qv-overlay");
  var modal = document.getElementById("ds-qv-modal");
  var thumbsTemplate = document.getElementById("ds-qv-thumb-template");

  function closeModal() {
    overlay.classList.remove("is-open");
    modal.classList.remove("is-open");
  }
  function openModal() {
    overlay.classList.add("is-open");
    modal.classList.add("is-open");
  }

  overlay.addEventListener("click", closeModal);
  document.addEventListener("click", function (e) {
    if (e.target.closest(".ds-qv-close")) {
      e.preventDefault();
      closeModal();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });

  // Refresh cart via /cart.js (simpler): update counters and emit event for theme scripts
  async function refreshCartUI() {
    try {
      var res = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
      });
      if (!res.ok) return;
      var cart = await res.json();
      // Update all cart counters
      document.querySelectorAll("cart-count").forEach(function (el) {
        el.textContent = cart.item_count;
      });
      // Let theme scripts react (e.g., re-render drawer internally if supported)
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: { cart: cart, source: "quick-view" },
        })
      );
    } catch (e) {}
  }

  function renderProduct(data, handle) {
    modal.querySelector(".ds-qv-title").textContent = data.title || "Product";
    modal.querySelector(".ds-qv-title-lg").textContent = data.title || "";
    modal.querySelector(".ds-qv-vendor").textContent = data.vendor || "";

    // Elements
    var priceEl = modal.querySelector(".ds-qv-price");
    var compareEl = modal.querySelector(".ds-qv-compare");
    var badgeEl = modal.querySelector(".ds-qv-badge");
    var stockEl = modal.querySelector(".ds-qv-stock");
    var skuValEl = modal.querySelector(".ds-qv-sku-value");
    var descEl = modal.querySelector(".ds-qv-desc");
    var variantWrap = modal.querySelector(".ds-qv-variants");
    var variantSelect = modal.querySelector(".ds-qv-variant-select");
    var qtyInput = modal.querySelector(".ds-qv-qty-input");
    var addBtn = modal.querySelector(".ds-qv-btn--add");
    var alertEl = modal.querySelector(".ds-qv-alert");
    var bulletEl = modal.querySelector(".ds-qv-bulletpoints");

    var i18nInStock = modal.getAttribute("data-i18n-in-stock") || "In stock";
    var i18nOutOfStock =
      modal.getAttribute("data-i18n-out-of-stock") || "Out of stock";
    var i18nSoldOutSuffix =
      modal.getAttribute("data-i18n-soldout-suffix") || "— Sold out";
    var i18nAdded = modal.getAttribute("data-i18n-added") || "Added to cart";
    var i18nYouSave =
      modal.getAttribute("data-i18n-you-save") || "You save {{ amount }}";

    // Description (plain text excerpt for cleanliness)
    if (descEl) {
      var tmp = document.createElement("div");
      tmp.innerHTML = data.description || "";
      var plain = (tmp.textContent || "").trim().replace(/\s+/g, " ");
      // Show full plain text; visual truncation (if needed) handled via CSS line-clamp
      descEl.textContent = plain;
    }

    // Bulletpoints: render the first <ul> from description if present
    if (bulletEl) {
      bulletEl.hidden = true;
      bulletEl.innerHTML = "";
      var parse = document.createElement("div");
      parse.innerHTML = data.description || "";
      var firstUl = parse.querySelector("ul");
      if (firstUl && firstUl.children.length) {
        // Sanitize by cloning only list items and their text content
        var ul = document.createElement("ul");
        Array.prototype.forEach.call(firstUl.children, function (li) {
          if (li.tagName && li.tagName.toLowerCase() === "li") {
            var newLi = document.createElement("li");
            newLi.textContent = (li.textContent || "").trim();
            ul.appendChild(newLi);
          }
        });
        if (ul.children.length) {
          bulletEl.appendChild(ul);
          bulletEl.hidden = false;
        }
      }
    }

    var viewBtn = modal.querySelector('[data-action="view-product"]');
    viewBtn.href = "/products/" + handle;

    var mainImg = modal.querySelector(".ds-qv-media-main img");
    if (mainImg) mainImg.alt = data.title || "";
    var imgs = (data.images || []).map(function (img) {
      return typeof img === "string" ? img : img.src;
    });
    if (imgs.length) mainImg.src = imgs[0];
    else mainImg.removeAttribute("src");

    var thumbs = modal.querySelector(".ds-qv-thumbs");
    while (thumbs.firstChild) thumbs.removeChild(thumbs.firstChild);
    imgs.forEach(function (src, idx) {
      var t =
        thumbsTemplate && "content" in thumbsTemplate
          ? thumbsTemplate.content.firstElementChild.cloneNode(true)
          : (function () {
              // Fallback: create element structurally without HTML string
              var btn = document.createElement("button");
              btn.className = "ds-qv-thumb";
              btn.setAttribute("role", "tab");
              btn.setAttribute("aria-selected", "false");
              var img = document.createElement("img");
              btn.appendChild(img);
              return btn;
            })();
      if (idx === 0) t.classList.add("is-active");
      t.setAttribute("aria-selected", idx === 0 ? "true" : "false");
      var tImg = t.querySelector("img");
      if (tImg) tImg.src = src;
      t.addEventListener("click", function () {
        selectIndex(idx);
      });
      thumbs.appendChild(t);
    });

    var current = 0;
    var selectedVariant = (data.variants && data.variants[0]) || null;

    function updateUIForVariant(v) {
      if (!v) return;
      selectedVariant = v;
      var price = parseInt(v.price, 10);
      var compare = v.compare_at_price
        ? parseInt(v.compare_at_price, 10)
        : null;
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = money(compare);
          compareEl.style.display = "inline";
          if (badgeEl) {
            var diff = compare - price;
            badgeEl.textContent = i18nYouSave.replace(
              "{{ amount }}",
              money(diff)
            );
            badgeEl.hidden = false;
          }
        } else {
          compareEl.textContent = "";
          compareEl.style.display = "none";
          if (badgeEl) badgeEl.hidden = true;
        }
      }
      if (stockEl)
        stockEl.textContent = v.available ? i18nInStock : i18nOutOfStock;
      if (skuValEl) skuValEl.textContent = v.sku || "";
      if (addBtn) addBtn.disabled = !v.available;
      // Update image to variant featured image if present
      if (v.featured_image && v.featured_image.src) {
        mainImg.src = v.featured_image.src;
      }
    }

    // Variants
    if (variantWrap && variantSelect) {
      var hasRealVariants = (data.variants || []).some(function (v) {
        return (v.title || "").toLowerCase() !== "default title";
      });
      if (hasRealVariants && data.variants && data.variants.length > 0) {
        variantWrap.hidden = false;
        // Build options
        variantSelect.innerHTML = "";
        (data.variants || []).forEach(function (v) {
          var opt = document.createElement("option");
          opt.value = String(v.id);
          opt.textContent =
            v.title + (v.available ? "" : " " + i18nSoldOutSuffix);
          if (!v.available) opt.disabled = true;
          variantSelect.appendChild(opt);
        });
        // Preselect first available variant if possible
        var firstAvailable =
          (data.variants || []).find(function (v) {
            return v.available;
          }) || data.variants[0];
        variantSelect.value = String(firstAvailable.id);
        updateUIForVariant(firstAvailable);
        variantSelect.onchange = function () {
          var id = variantSelect.value;
          var v = (data.variants || []).find(function (x) {
            return String(x.id) === id;
          });
          updateUIForVariant(v || data.variants[0]);
        };
      } else {
        variantWrap.hidden = true;
        updateUIForVariant(selectedVariant);
      }
    } else {
      updateUIForVariant(selectedVariant);
    }

    // Add to cart
    if (addBtn) {
      addBtn.onclick = async function () {
        try {
          var qty = parseInt(
            qtyInput && qtyInput.value ? qtyInput.value : "1",
            10
          );
          if (!qty || qty < 1) qty = 1;
          addBtn.disabled = true;
          var res = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ id: selectedVariant.id, quantity: qty }),
          });
          if (!res.ok) throw new Error("Cart");
          if (alertEl) {
            // Show success message and auto-hide after 3000ms
            alertEl.textContent = i18nAdded;
            alertEl.hidden = false;
            if (addBtn._alertTimer) clearTimeout(addBtn._alertTimer);
            addBtn._alertTimer = setTimeout(function () {
              alertEl.hidden = true;
              alertEl.textContent = "";
            }, 3000);
          }
          // Refresh cart drawer and counters so the new line item is reflected
          try {
            await refreshCartUI();
            // Ask theme's CartDrawer to fetch and re-render its section
            document.dispatchEvent(
              new CustomEvent("cart:refresh", {
                detail: { source: "quick-view" },
              })
            );
          } catch (e) {}
        } catch (err) {
          if (alertEl) {
            alertEl.textContent = "";
            alertEl.hidden = true;
          }
          console.error(err);
        } finally {
          addBtn.disabled = !selectedVariant.available;
        }
      };
    }
    function selectIndex(i) {
      current = (i + imgs.length) % imgs.length;
      mainImg.src = imgs[current];
      Array.prototype.forEach.call(thumbs.children, function (el, j) {
        el.classList.toggle("is-active", j === current);
        el.setAttribute("aria-selected", j === current ? "true" : "false");
      });
    }

    modal.querySelector(".ds-qv-prev").onclick = function () {
      if (imgs.length) selectIndex(current - 1);
    };
    modal.querySelector(".ds-qv-next").onclick = function () {
      if (imgs.length) selectIndex(current + 1);
    };

    // expose for keyboard nav on main image
    mainImg.tabIndex = 0;
    mainImg.onkeydown = function (e) {
      if (e.key === "ArrowLeft") {
        modal.querySelector(".ds-qv-prev").click();
      }
      if (e.key === "ArrowRight") {
        modal.querySelector(".ds-qv-next").click();
      }
    };
  }

  async function openQuickView(handle) {
    openModal();
    var i18nLoading = modal.getAttribute("data-i18n-loading") || "Loading…";
    var i18nErrorTitle = modal.getAttribute("data-i18n-error-title") || "Error";
    var i18nErrorMsg =
      modal.getAttribute("data-i18n-error-message") || "Could not load product";
    modal.querySelector(".ds-qv-title").textContent = i18nLoading;
    modal.querySelector(".ds-qv-title-lg").textContent = "";
    modal.querySelector(".ds-qv-vendor").textContent = "";
    modal.querySelector(".ds-qv-price").textContent = "";
    var bulletEl = modal.querySelector(".ds-qv-bulletpoints");
    if (bulletEl) {
      bulletEl.innerHTML = "";
      bulletEl.hidden = true;
    }
    var descEl = modal.querySelector(".ds-qv-desc");
    if (descEl) {
      descEl.textContent = "";
    }
    var thumbs = modal.querySelector(".ds-qv-thumbs");
    while (thumbs.firstChild) thumbs.removeChild(thumbs.firstChild);
    var mainImg = modal.querySelector(".ds-qv-media-main img");
    mainImg.removeAttribute("src");

    try {
      var res = await fetch("/products/" + encodeURIComponent(handle) + ".js");
      if (!res.ok) throw new Error("Network");
      var data = await res.json();

      renderProduct(data, handle);
    } catch (e) {
      modal.querySelector(".ds-qv-title").textContent = i18nErrorTitle;
      modal.querySelector(".ds-qv-title-lg").textContent = i18nErrorMsg;
    }
  }

  // Delegate clicks
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest(".quick-view-btn");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute("data-handle");
      if (!handle) {
        var card = btn.closest("product-card");
        if (card) handle = card.getAttribute("handle");
      }
      if (handle) openQuickView(handle);
    },
    true
  );
})();
